import React from "react";
import PointOfSaleCore from "../../components/PointOfSale/Core/index";
import SupermarketPreorder from "./SupermarketPreorder";
import ModuleGate from "../ModuleGate";

const Preorder = () => (
  <ModuleGate module="preorder">
    <PointOfSaleCore component={SupermarketPreorder} />
  </ModuleGate>
);

export default Preorder;
